import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onImportCredits, onCreateClaim, onGenerateReport, onViewRegistry }) => {
  const actions = [
    {
      id: 'import',
      title: 'Import Credits',
      description: 'Add new credits from registries',
      icon: 'Upload',
      variant: 'default',
      onClick: onImportCredits
    },
    {
      id: 'claim',
      title: 'Create VCMI Claim',
      description: 'Build compliance-ready claims',
      icon: 'FileText',
      variant: 'outline',
      onClick: onCreateClaim
    },
    {
      id: 'report',
      title: 'Generate Report',
      description: 'Export portfolio analytics',
      icon: 'BarChart3',
      variant: 'outline',
      onClick: onGenerateReport
    },
    {
      id: 'registry',
      title: 'Registry Status',
      description: 'Check connector health',
      icon: 'Link',
      variant: 'ghost',
      onClick: onViewRegistry
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-card-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <div key={action?.id} className="group">
            <Button
              variant={action?.variant}
              fullWidth
              iconName={action?.icon}
              iconPosition="left"
              onClick={action?.onClick}
              className="h-auto p-4 justify-start"
            >
              <div className="text-left">
                <div className="font-medium">{action?.title}</div>
                <div className="text-xs opacity-70 mt-1">{action?.description}</div>
              </div>
            </Button>
          </div>
        ))}
      </div>
      {/* Additional Quick Stats */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-lg font-semibold text-card-foreground">12</div>
            <div className="text-xs text-muted-foreground">Active Registries</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-card-foreground">98.5%</div>
            <div className="text-xs text-muted-foreground">System Uptime</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-card-foreground">24/7</div>
            <div className="text-xs text-muted-foreground">Monitoring</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;